module.exports = __webpack_public_path__ + "img/utk.2e727645.svg";